import React from "react";

// Crypto wallet (WalletConnect / MetaMask) sign-in has been disabled — the web3 SDK
// caused connection failures and blank screens, and is not supported for deployment.
// Sign-in is via Phone OTP and Google. This stub keeps the provider a no-op pass-through.
export const projectId = "";
export const appKitReady = false;

export function Web3Providers({ children }) {
  return children;
}
